import { Injectable } from '@angular/core';
import * as Klaro from 'klaro';
import { KLARO_CONFIG, KLARO_SERVICE_ANALYTIQUE } from './klaro.config';

interface KlaroManager {
  watch(watcher: { update: (obj: unknown, name: string, data: unknown) => void }): void;
  getConsent(name: string): boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ConsentementService {
  private initialise = false;
  private klaro: typeof Klaro = Klaro;

  public initialiser(): void {
    if (this.initialise) {
      return;
    }
    this.initialise = true;
    (window as any).klaroConfig = KLARO_CONFIG;
    this.klaro.setup(KLARO_CONFIG);
  }

  public analytiqueAutorisee(): boolean {
    return this.manager()?.getConsent(KLARO_SERVICE_ANALYTIQUE) === true;
  }

  public surConsentement(callback: (autorise: boolean) => void): void {
    const manager = this.manager();
    if (!manager) {
      return;
    }
    manager.watch({
      update: (_obj, name, data) => {
        if (name === 'consents') {
          callback(!!(data as Record<string, boolean>)?.[KLARO_SERVICE_ANALYTIQUE]);
        }
      },
    });
    if (this.analytiqueAutorisee()) {
      callback(true);
    }
  }

  public ouvrirPreferences(): void {
    this.klaro.show(KLARO_CONFIG, true);
  }

  private manager(): KlaroManager | null {
    return (this.klaro.getManager?.(KLARO_CONFIG) as KlaroManager) ?? null;
  }
}
